module.exports = __webpack_public_path__ + "static/flexbox-17008362237f84f0537bab1077ff0d2c.jpg";